import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const clientAccountApi = createApi({
  reducerPath: "clientAccount",
  refetchOnFocus: true,
  refetchOnReconnect: true,
  baseQuery: fetchBaseQuery({
    baseUrl: window.location.origin,
    withCredentials: true
  }),
  endpoints: build => ({
    getAccount: build.query({
      query: id => `/api/ClientAccount/${id}`
    }),
    getAccounts: build.query({
      query: searchCriteria => ({
        url: '/api/ClientAccount/Search',
        method: 'POST',
        body: searchCriteria
      }),
      providesTags: ['Accounts']
    }),
    addAccount: build.mutation({
      query: account => ({
        url: '/api/ClientAccount/',
        method: 'POST',
        body: account
      }),
      invalidatesTags: ['Accounts']
    }),
    saveAccount: build.mutation({
      query: account => ({
        url: '/api/ClientAccount/',
        method: 'PUT',
        body: account
      }),
      invalidatesTags: ['Accounts']
    }),
    resendInvitationEmail: build.mutation({
      query: id => ({
        url: '/api/ClientAccount/ResendInvitationEmail',
        method: 'POST',
        body: id
      }),
      invalidatesTags: ['Accounts']
    })
  }),
  tagTypes: ['Accounts']
})

export const { useGetAccountQuery, useGetAccountsQuery, useAddAccountMutation, useSaveAccountMutation, useResendInvitationEmailMutation } = clientAccountApi
